import React from "react";

function NoIncompleteAction() {
    return (
        <div className="box-description null-body-detected-breach">
            <div className="row row-container">
                <div className="col-sm-3"></div>
                <div className="col-xs-12 col-sm-6 text-align-center col-main">
                    <div className="icon-main">
                        <em className="las la-check-circle complete-icon"></em>
                    </div>
                    <div>
                        <div className="title-main">You have completed all open actions.</div>
                        <div className="description">Great job! Taking action helps keep your identity safe.</div>
                    </div>
                </div>
                <div className="col-sm-3"></div>
            </div>
        </div>
    );
}

export default NoIncompleteAction;
